

export enum ByggsokEventType {
    LOGG_INN_PAA_NYTT,
    REFRESH_COOKIE,
    RELOAD_DATA,
    NETWORK_ERROR,
    FETCH_ERROR
}